import ReportService from "../../../services/ReportService";
class AuditFilter {
  momentToFormat = (m) => m.format("YYYY-MM-DD");

  async getAuditReport(fromDate, toDate) {
    try {
      const response = await ReportService.getAuditReport(
        this.momentToFormat(fromDate),
        this.momentToFormat(toDate)
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
}
const auditFilter = new AuditFilter();
export default auditFilter;
